import React from "react";
import { useLanguage } from "../context/LanguageContext";

function ComponentDescription({ title, text }) {
  const { lang } = useLanguage();

  return (
    <div className="w-full rounded-lg bg-white p-4 shadow border-l-4 border-indigo-500">
      <h2 className="text-lg font-semibold text-indigo-600">{title}</h2>
      <p className="mt-1 text-sm text-gray-600">{text[lang]}</p>
    </div>
  );
}

export default ComponentDescription;



